import { useState } from "react";
import { SeguroDesempregoInputCard } from "./components/SeguroDesempregoInputCard";
import { SeguroDesempregoResponseCard } from "./components/SeguroDesempregoResponseCard";
import type { SeguroDesempregoResultsType } from "./calculadora-seguro-desemprego";

export default function CalculadoraSeguroDesemprego() {
  const [results, setResults] = useState<SeguroDesempregoResultsType | null>(null);

  return (
    <>
      <SeguroDesempregoInputCard setResults={setResults} />
      {results && <SeguroDesempregoResponseCard results={results} />}
    </>
  );
}